import { render, staticRenderFns } from "./changeManage.vue?vue&type=template&id=0bb4a22e&"
import script from "./changeManage.vue?vue&type=script&lang=js&"
export * from "./changeManage.vue?vue&type=script&lang=js&"
import style0 from "./changeManage.vue?vue&type=style&index=0&id=0bb4a22e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports